import { TableCell, TableRow } from '@mui/material'
import config from '../../../config.json'
import Link from '../../common/util/input/Link'
import { formatUSD, formatWAX } from '../../helpers/FormatLinks'
import PreviewGraphic from '../../previews/PreviewGraphic'

const UsersTableElement = ({ index, user, userType }) => {
    const { userName, image, stats } = user

    const {
        usdVolume,
        waxVolume,
        usdBuyVolume,
        waxBuyVolume,
        usdSellVolume,
        waxSellVolume,
        purchases,
        sales,
    } = stats

    const previewPicUrl = image
        ? image
        : 'QmVVE5aLtq4EtMe4Khev5CSic3AKqX2RuNTAB79thvpqQW'

    const collection = image ? userName : 'wax'

    return (
        <TableRow key={'ranking-detail-row' + index}>
            <TableCell>{user.stats.rank}</TableCell>
            <TableCell>
                <Link href={'/user/' + userName}>
                    <div className={'flex'}>
                        <div className={'pr-2'}>
                            <PreviewGraphic
                                size={240}
                                hash={previewPicUrl}
                                collection={collection}
                            />
                        </div>
                        <div className={'my-auto hover:underline max-w-40'}>
                            {userName}
                        </div>
                    </div>
                </Link>
            </TableCell>

            {['all'].includes(userType) && (
                <TableCell>{`${formatWAX(waxVolume)} / ${formatUSD(
                    usdVolume,
                )}`}</TableCell>
            )}
            {['all'].includes(userType) && (
                <TableCell>{`${formatWAX(waxBuyVolume)} / ${formatUSD(
                    usdBuyVolume,
                )}`}</TableCell>
            )}
            {['buyer'].includes(userType) && (
                <TableCell>{`${formatWAX(waxBuyVolume)}`}</TableCell>
            )}
            {['buyer'].includes(userType) && (
                <TableCell>{`${formatUSD(usdBuyVolume)}`}</TableCell>
            )}
            {['all'].includes(userType) && (
                <TableCell>{`${formatWAX(waxSellVolume)} / ${formatUSD(
                    usdSellVolume,
                )}`}</TableCell>
            )}
            {['seller'].includes(userType) && (
                <TableCell>{`${formatWAX(waxSellVolume)}`}</TableCell>
            )}
            {['seller'].includes(userType) && (
                <TableCell>{`${formatUSD(usdSellVolume)}`}</TableCell>
            )}
            {['buyer', 'all'].includes(userType) && (
                <TableCell>
                    {purchases ? purchases.toLocaleString(undefined) : 0}
                </TableCell>
            )}
            {['seller', 'all'].includes(userType) && (
                <TableCell>
                    {sales ? sales.toLocaleString(undefined) : 0}
                </TableCell>
            )}
        </TableRow>
    )
}

export default UsersTableElement
